import BaseListPresenter from "../../base/BaseListPresenter";
import { findObjectUseCase } from "../../usecases/object";
import { getCurrentUserUseCase } from "../../usecases/user";
import {
  format,
  startOfDay,
  addHours,
  addMinutes,
  addDays,
  parseISO,
} from "date-fns";
import Papa from "papaparse";

class LogsPresenter extends BaseListPresenter {
  init() {
    // this.limit = 2000000;
    this.where = {};
    this.search = {};
    this.filter = {};
    this.filterDate = {};
    this.filterStore = {};
    this.filterType = {};
    this.filterStore = {};
    this.status = "V";
    this.include = ["all"];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { tran_date: -1 };
    this.progress = true;
    this.reset();
  }

  componentDidMount() {
    this.init();
    return this.getObjects();
  }

  async getObjects() {
    this.reset();
    // await this.countObjects();
    await this.findObjects();
  }

  createQuery() {
    const query = {
      // limit: 2000000,
      skip: (this.current - 1) * this.limit,
      where: {
        status: "C",
        reopen: "Y",
        tran_date: this.filterDate,
      },
      include: ["all"],
      sort: this.sort,
      keys: [
        "store_code",
        "tran_date",
        "total",
        "total_taxfree",
        "total_tax",
        "discount_amount",
        "createdAt",
        "cust_name",
        "status",
        "logsArray",
        "paymenttypetotal",
        "paymenttype2",
        "paymenttype2total",
        "paymenttype3",
        "paymenttype3total",
        "reopen",
        "reopen_user_id",
      ],
    };
    return query;
  }

  // async findObjects() {
  //   try {
  //     const user = await getCurrentUserUseCase().execute();
  //     const storeQuery = {
  //       include: ["all"],
  //       where: { email: user.email },
  //     };
  //     this.store = await this.findObjectUseCase.execute("users", storeQuery);

  //     const store =
  //       this.store[0]?.storeAnalytic?.sort((a, b) =>
  //         a.name.localeCompare(b.name, undefined, { sensitivity: "base" })
  //       ) || [];

  //     this.view.setStore(store);
  //   } catch (error) {
  //     console.error("Error fetching user/store:", error);
  //     return;
  //   }

  //   if (Object.keys(this.filterStore).length === 0) return;
  //   const skip = (this.current - 1) * this.limit;

  //   const storeCodes = this.store?.flatMap((user) =>
  //     user.storeAnalytic?.map((analytic) => analytic?.name)
  //   );

  //   const where = {
  //     status: "V",
  //     ...this.filterDate, // includes tran_date if set
  //   };

  //   if (this.filterStore === "AllStore") {
  //     where.store_code = { $in: storeCodes };
  //   } else if (this.filterStore) {
  //     where.store_code = this.filterStore;
  //   }

  //   const query = {
  //     // limit: 2000000,
  //     skip,
  //     where,
  //     include: ["all"],
  //     sort: this.sort,
  //     keys: [
  //       "store_code",
  //       "tran_date",
  //       "total",
  //       "total_taxfree",
  //       "total_tax",
  //       "discount_amount",
  //       "createdAt",
  //       "cust_name",
  //       "tran_type",
  //       "paymenttype",
  //       "cust_count",
  //       "total_pretax",
  //       "status",
  //       "logsArray",
  //       "paymenttypetotal",
  //       "paymenttype2",
  //       "paymenttype2total",
  //       "paymenttype3",
  //       "paymenttype3total",
  //       "reopen",
  //       "reopen_user_id",
  //     ],
  //   };

  //   try {
  //     this.showProgress();
  //     // const objects = await findObjectUseCase().execute(
  //     //   this.view.getCollectionName(),
  //     //   query
  //     // );

  //     // this.objects = objects;
  //     // this.view.setTotal(objects.length);
  //     // this.view.setObjects(objects);

  //     const { count } = await this.countObjectUseCase.execute(
  //       this.view.getCollectionName(),
  //       {
  //         where: query.where,
  //       }
  //     );
  //     this.count = count;
  //     console.log("this.count", this.count);
  //     this.view.setCount(this.count);

  //     // Batching logic
  //     let buffer = [];
  //     let flushInterval = null;

  //     const flushBuffer = () => {
  //       if (buffer.length > 0) {
  //         this.view.setState((prevState) => ({
  //           objects: [...prevState.objects, ...buffer],
  //         }));
  //         this.objects = this.objects.concat(buffer);
  //         buffer = [];
  //         this.view.setTotal(this.objects.length);
  //         this.view.setObjects(this.objects);
  //       }
  //     };

  //     const onData = (objects) => {
  //       buffer.push(...objects);
  //     };

  //     flushInterval = setInterval(flushBuffer, 2000);

  //     const objects = await this.findObjectUseCase.execute(
  //       this.view.getCollectionName(),
  //       query,
  //       {
  //         timeout: 100000,
  //         onData,
  //       }
  //     );

  //     // Final flush and cleanup
  //     clearInterval(flushInterval);
  //     flushBuffer();

  //     // ✅ Check if no data was returned
  //     if (!this.count) {
  //       const not = true;
  //       // alert("wrok");
  //       this.view.setObjects([]);
  //       this.view.setNotFound(not);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching objects:", error);
  //     this.view.showError(error);
  //   } finally {
  //     this.hideProgress();
  //     this.progress = false;
  //   }
  // }

  async findObjects() {
    try {
      const user = await getCurrentUserUseCase().execute();
      const storeQuery = {
        include: ["all"],
        where: { email: user.email },
      };
      this.store = await this.findObjectUseCase.execute("users", storeQuery);

      const store =
        this.store[0]?.storeAnalytic?.sort((a, b) =>
          a.name.localeCompare(b.name, undefined, { sensitivity: "base" })
        ) || [];

      this.view.setStore(store);
    } catch (error) {
      console.error("Error fetching user/store:", error);
      return;
    }

    if (Object.keys(this.filterStore).length === 0) return;

    const skip = (this.current - 1) * this.limit;

    const storeCodes = this.store?.flatMap((user) =>
      user.storeAnalytic?.map((analytic) => analytic?.name)
    );

    const where = {
      // status: "C",
      reopen: "Y",
      ...this.filterDate,
    };

    if (this.filterStore === "AllStore") {
      where.store_code = { $in: storeCodes };
    } else if (this.filterStore) {
      where.store_code = this.filterStore;
    }

    const query = {
      skip,
      where,
      include: ["all"],
      sort: this.sort,
      keys: [
        "store_code",
        "tran_date",
        "total",
        "total_taxfree",
        "total_tax",
        "discount_amount",
        "createdAt",
        "cust_name",
        "tran_type",
        "paymenttype",
        "cust_count",
        "total_pretax",
        "status",
        "logsArray",
        "paymenttypetotal",
        "paymenttype2",
        "paymenttype2total",
        "paymenttype3",
        "paymenttype3total",
        "reopen",
        "reopen_user_id",
      ],
    };

    try {
      this.showProgress();
      this.findObjectUseCase.abort();

      const { count } = await this.countObjectUseCase.execute(
        this.view.getCollectionName(),
        { where: query.where }
      );

      this.count = count;
      console.log("this.count", this.count);
      this.view.setCount(this.count);

      // Reset objects & view state
      this.objects = [];
      this.view.setObjects([]);
      this.view.setTotal(0);
      this.view.setNotFound(false);

      let timeoutId = null;

      // Handle delayed "not found"
      if (this.count === 0) {
        timeoutId = setTimeout(() => {
          if (this.count === 0) {
            this.view.setNotFound(true);
            this.view.setObjects([]);
            this.view.setTotal(0);
          }
        }, 30000); // 15 seconds delay
      }

      // Batching logic
      let buffer = [];

      const flushBuffer = () => {
        if (buffer.length > 0) {
          this.view.setState((prevState) => ({
            objects: [...prevState.objects, ...buffer],
          }));
          this.objects = this.objects.concat(buffer);
          this.view.setTotal(this.objects.length);
          this.view.setObjects(this.objects);
          buffer = [];
        }
      };

      const onData = (objects) => {
        if (objects.length > 0 && timeoutId) {
          clearTimeout(timeoutId);
          timeoutId = null;
          this.view.setNotFound(false);
        }
        buffer.push(...objects);
      };

      const flushInterval = setInterval(flushBuffer, 2000);

      await this.findObjectUseCase.execute(
        this.view.getCollectionName(),
        query,
        {
          timeout: 100000,
          onData,
        }
      );

      clearInterval(flushInterval);
      flushBuffer();
    } catch (error) {
      console.error("Error fetching objects:", error);
      this.view.showError(error);
    } finally {
      this.hideProgress();
      this.progress = false;
    }
  }

  onChangeDate(where) {
    const { tran_date } = where;

    if (tran_date && tran_date.$gte && tran_date.$lte) {
      const startDate = addHours(startOfDay(parseISO(tran_date.$gte)), 5);
      const endDate = addMinutes(
        addHours(addDays(startOfDay(parseISO(tran_date.$lte)), 0), 4),
        59
      );

      const formattedStartDate = format(startDate, "yyyy-MM-dd HH:mm:ss.SSS");
      const formattedEndDate = format(endDate, "yyyy-MM-dd HH:mm:ss.SSS");

      this.filterDate = {
        tran_date: {
          $gte: formattedStartDate,
          $lte: formattedEndDate,
        },
      };
    }
  }

  onChangeStore(where) {
    this.filterStore = where;
  }

  applyFilters(range, store) {
    this.onChangeDate(range);
    this.onChangeStore(store);
    this.getObjects();
  }

  async onClickExport() {
    const objects = this.view.getObjects();
    const collection = this.view.getCollectionName();

    if (objects.length === 0) {
      console.log("No objects selected for export.");
      return;
    }
    const csv = Papa.unparse(objects);

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

    const link = document.createElement("a");
    if (link.download !== undefined) {
      // feature detection
      // Create a URL for the Blob and set it as the href attribute
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      // Set the download attribute with a filename
      link.setAttribute("download", `${collection}_void_export.csv`);
      // Append the link to the document body
      document.body.appendChild(link);
      // Programmatically click the link to trigger the download
      link.click();
      // Clean up and remove the link
      document.body.removeChild(link);
    }
  }
}

export default LogsPresenter;
